var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5438_4250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2859 68.2843C83.9069 52.6633 83.9069 27.3367 68.2859 11.7157C52.6649 -3.90524 27.3383 -3.90524 11.7174 11.7157C-3.90359 27.3367 -3.90359 52.6633 11.7174 68.2843C27.3383 83.9052 52.6649 83.9052 68.2859 68.2843Z",
    fill: "#9FC914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 77.7616C60.8553 77.7616 77.7618 60.8551 77.7618 39.9998C77.7618 19.1446 60.8553 2.23804 40.0001 2.23804C19.1448 2.23804 2.23828 19.1446 2.23828 39.9998C2.23828 60.8551 19.1448 77.7616 40.0001 77.7616Z",
    fill: "#45EFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7391 49.6293C39.3743 48.7153 27.701 37.1644 26.6143 22.8139C26.5207 21.5976 26.5063 20.3957 26.5639 19.2083C26.7222 15.8833 22.8863 13.9042 20.3098 16.0129C12.9907 22.0294 8.47106 31.3277 9.01082 41.6552C9.83846 57.5098 22.8215 70.3418 38.6834 70.9967C51.2922 71.5149 62.3106 64.5051 67.629 54.0985C69.1332 51.155 66.3768 47.8373 63.1886 48.6937C60.2019 49.4925 57.0209 49.8308 53.7391 49.6221V49.6293Z",
    fill: "#69FFC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6362 37.4523C63.5269 42.634 53.185 41.2666 44.5272 34.4008C35.8694 27.535 32.1846 17.7761 36.294 12.5944C40.4034 7.41268 50.7453 8.78008 59.4031 15.6459C68.0609 22.5116 71.7456 32.2705 67.6362 37.4523Z",
    fill: "#69FFC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9057 0 0 17.9057 0 40C0 62.0943 17.9057 80 40 80C62.0943 80 80 62.0943 80 40C80 17.9057 62.0943 0 40 0ZM40 74.041C21.2019 74.041 5.95898 58.7981 5.95898 40C5.95898 21.2019 21.2019 5.95898 40 5.95898C58.7981 5.95898 74.041 21.2019 74.041 40C74.041 58.7981 58.7981 74.041 40 74.041Z",
    fill: "#3ACF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5471 47.5495C18.3711 44.3734 18.3703 39.2242 21.5453 36.0471C24.7218 32.8686 29.8738 32.8678 33.0513 36.0453L34.2568 37.2508L46.9514 24.5611C50.1277 21.3861 55.2763 21.3866 58.4519 24.5622C61.628 27.7383 61.628 32.8878 58.4519 36.0639L35.671 58.8448C34.8899 59.6259 33.6236 59.6259 32.8425 58.8448L21.5471 47.5495Z",
    fill: "#3ACF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9036 42.6927L34.2571 43.0458L34.6105 42.6925L49.8494 27.4595C51.4252 25.8844 53.9794 25.8846 55.5548 27.4601C57.1304 29.0357 57.1304 31.5903 55.5548 33.166L35.3176 53.4031C34.7318 53.9889 33.7821 53.9889 33.1963 53.4031L28.3446 48.5514V48.544L28.198 48.3976L24.4481 44.6516C22.8713 43.0764 22.8706 40.5209 24.4467 38.9449C26.0215 37.37 28.5747 37.3693 30.1504 38.9434L33.9036 42.6927Z",
    fill: "white",
    stroke: "#3ACF9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5438_4250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckActive);
export default __webpack_public_path__ + "static/media/checkActive.472d36d0551284944720886ea678af2e.svg";
export { ForwardRef as ReactComponent };